import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'oap-magazine',
  templateUrl: './magazine.component.html',
  styleUrls: ['./magazine.component.scss']
})
export class MagazineComponent implements OnInit {
  public articles;

  constructor() { }

  ngOnInit() {
    this.setArticles();
  }

  setArticles() {
    this.articles = [
      {
        slug: 'votre-espace-Ordo-IZZY-toujours-plus-pratique-pour-vous-accompagner-au-quotidien',
        category: 'Newsletter Janvier 2022',
        title: 'Votre espace Ordo IZZY toujours plus pratique pour vous accompagner au quotidien !',
        image: './assets/images/magazines/2022/01/jan22-1.png',
        description: "STALLERGENES GREER vous présente ses meilleurs vœux pour cette nouvelle année et vous informe que de nouvelles fonctionnalités sont disponibles sur votre espace Ordo IZZY.",
      },
      {
        slug: 'evaluer-l’exposition-quotidienne-aux-allergenes-:-pourquoi-faire-appel-a-un-conseiller-medical-en-environnement-interieur-CMEI',
        category: 'Newsletter Novembre 2021',
        title: 'Évaluer l’exposition quotidienne aux allergènes : pourquoi faire appel à un Conseiller Médical en Environnement Intérieur (CMEI) ?',
        image: './assets/images/magazines/2021/11/adobestock-181311944.jpg',
        description: 'Pour répondre à cette question, l’équipe ORDO IZZY s’entretient avec Pascale Couratier, CMEI et Directrice Générale de l’Association Française pour la Prévention des Allergies (AFPRAL). ',
      },
      {
        slug: 'prenez-part-a-une-web-conference-organisee-par-l-association-Asthme-&-Allergies-pour-lutter-contre-les-«-fake-news-»',
        category: 'Newsletter Septembre 2021',
        title: 'Prenez part à une web conférence organisée par l’association Asthme & Allergies pour lutter contre les « fake news »',
        image: './assets/images/magazines/prenez-part-a-une-web-conference-organisee-par-lassociation-asthme-allergies-pour-lutter-contre-les-fake-news.jpeg',
        description: 'Conscient et soucieux que de nombreuses informations fausses circulent sur les allergies, STALLERGENES GREER apporte son soutien institutionnel à l’association Asthme & Allergies qui vous invite à participer à sa web conférence intitulée Allergies : gare aux « fake news » !',
      },
      {
        slug: 'alertes-aux-pollen-ayez-les-bons-reflexes',
        category: 'Newsletter Juin 2020',
        title: 'Alertes aux pollens : ayez les bons réflexes !',
        image: './assets/images/magazines/alertes-aux-pollen-ayez-les-bons-reflexes.jpg',
        description: 'En raison de la maladie COVID-19, le port du masque s’est démocratisé. Or, ce dispositif sanitaire est un puissant allié dans la lutte contre les allergies. Dans un communiqué récent, la Fédération française d’allergologie (FFAL) conseille de porter systématiquement un masque pour diminuer le risque d’allergie respiratoire. Pensez à le mettre, notamment quand vous faites des activités extérieures et êtes en contact avec des pollens allergisants. ',
      },
      {
        slug: 'les-allergies-ne-prennent-pas-de-vacances',
        category: 'Newsletter Décembre 2020',
        title: 'Les allergies ne prennent pas de vacances !',
        image: './assets/images/magazines/les-allergies-ne-prennent-pas-de-vacances.jpg',
        description: 'Vous avez un chat ou un chien à la maison ? Vous avez probablement constaté que sa fourrure laisse des traces sur le sol, le tapis et le canapé tout au long de l’année. Et au grand désarroi des personnes allergiques, ces chutes de poils sont accentuées en automne et en hiver, lors des périodes de mue. ',
      },
      {
        slug: 'stallergenes-greer-vous-souhaite-une-annee-2021-sous-le-signe-de-la-sante',
        category: 'Newsletter Janvier 2021',
        title: 'STALLERGENES GREER vous souhaite une année 2021 sous le signe de la santé !',
        image: './assets/images/magazines/2021.jpg',
        description: "Les personnes allergiques peuvent prendre des dispositions pour minimiser les contacts directs avec les allergènes : Éviter les promenades en nature en cas d'alerte pollinique; Laver ses cheveux et ses vêtements après une sortie à l’extérieur; Aérer la maison tôt le matin et tard le soir... ",
      },
      {
        slug: 'la-15eme-edition-de-la-journee-francaise-de-l-allergie',
        category: 'Newsletter Mai 2021',
        title: 'La 15ème édition de la Journée Française de l’Allergie',
        image: './assets/images/magazines/Logo-Allergie_2021-RVB-DEF.png',
        description: "Stallergenes Greer a pris part à la 15ème édition de la Journée Française de l’Allergie sous le thème des allergies de l’air intérieur. Cette édition 100% digitale a connu un franc succès parmi les internautes. Retrouvez ce qu’il faut savoir sur les allergies de l’air intérieur, les allergènes, les symptômes et les traitements de l’allergie sur le site internet de la JFA.",
      }
    ];
  }
}
